import { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
// import {
//   ChevronDown,
//   ChevronUp,
//   Square,
//   Minus,
//   Circle,
// } from "lucide-react";

// import "./Gallery.css";

export default function Gallery() {

  const [expanded, setExpanded] = useState(false);

  const galleryImages = [
    "../assets/gallery/img7.jpg",
    "../assets/gallery/img8.jpg",
    "../assets/gallery/img14.png",
    "../assets/gallery/wtp-img.png",
    "../assets/gallery/img4.jpg",
    "../assets/gallery/img3.png",
    "../assets/gallery/img2.jpg",
    "../assets/gallery/img1.png",
    "../assets/gallery/img6.png",
    "../assets/gallery/img15.png",
    "../assets/gallery/img16.png",
    "../assets/gallery/img18.png",
  ];

  const visibleImages = expanded
    ? galleryImages
    : galleryImages.slice(0, 3);


    const downIcon = <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
</svg>

const  upIcon = <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
</svg>
  return (
    <section className="gallery-section my-5">

      <Container>

        {/* Vintage Window */}
        <div className="figma-window">

          {/* Window Header */}
          <div className="window-topbar">

            <div className="window-actions">
              <span className="close-btn"></span>
              <span className="min-btn"></span>
              <span className="max-btn"></span>
            </div>

            <div className="window-title">
              divsGallery.fig | <Button
                className="topExpBtn"
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? (
                  <>
                    Less {upIcon}
                    {/* <ChevronUp size={18} /> */}
                  </>
                ) : (
                  <>
                    More {downIcon}
                    {/* <ChevronDown size={18} /> */}
                  </>
                )}
              </Button>
            </div>

          </div>

          {/* Gallery */}
          <div className="gallery-body">

            <Row className="g-4">

              {visibleImages.map((img, index) => (
                <Col lg={4} md={6} sm={12} key={index}>

                  <div className="gallery-card">

                    <img
                      src={img}
                      alt="gallery"
                      className="gallery-image"
                    />

                    <div className="gallery-overlay">
                      <p>Project Preview</p>
                    </div>

                  </div>

                </Col>
              ))}

            </Row>

            {/* Expand Button */}
            <div className="text-center mt-4">

              <Button
                className="expand-btn"
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? (
                  <>
                    Collapse {upIcon}
                    {/* <ChevronUp size={18} /> */}
                  </>
                ) : (
                  <>
                    View More {downIcon}
                    {/* <ChevronDown size={18} /> */}
                  </>
                )}
              </Button>

            </div>

          </div>

        </div>

      </Container>

    </section>
  );
}